/**
 * Direction utility — derives layout direction from BCP-47 language code.
 *
 * Used by app-level <html dir> setters and by the DsProvider `direction`
 * adapter that shared components consume via useDsDirection().
 *
 * Extensible: add new prefixes to RTL_PREFIXES when corresponding locales
 * are seeded in localization-seed-data.
 */
export type Direction = 'ltr' | 'rtl';

const RTL_PREFIXES = ['ar-', 'he-', 'fa-', 'ur-'];

export function getDirection(language: string): Direction {
  const lower = language.toLowerCase();
  return RTL_PREFIXES.some((p) => lower.startsWith(p)) ? 'rtl' : 'ltr';
}
